import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";

interface SEOProps {
  title?: string;
  description?: string;
  canonical?: string;
  image?: string;
}

export const SEO = ({ title, description, canonical, image }: SEOProps) => {
  const location = useLocation();
  const origin = window.location.origin;
  const currentUrl = `${origin}${location.pathname}`;
  const siteName = "Pididex";
  
  const fullTitle = title 
    ? `${title} | ${siteName}`
    : "Pididex - Crie sua Loja Online em Minutos";
    
  const fullDescription = description || "Monte sua loja online em minutos com 7 dias grátis. Receba pedidos via WhatsApp, aceite Pix e Mercado Pago.";
  const canonicalUrl = canonical || currentUrl;
  const ogImage = image || `${origin}/social-preview.png`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={fullDescription} />
      
      {/* Open Graph */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={fullDescription} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:image" content={ogImage} />
      
      {/* Twitter */}
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={fullDescription} />
      <meta name="twitter:image" content={ogImage} />
      
      {/* Canonical */}
      <link rel="canonical" href={canonicalUrl} />
    </Helmet>
  );
};
